mutation BootSnippetDomainSet($input: BootSnippetDomainSetInput!) {
    bootSnippetDomainSet(input: $input) {
        domainId
    }
}
